// extracted by css-extract-rspack-plugin
export default {"wrapper":"_b147fa6f"};